import axios from 'axios';

import { env } from "../../../env"
import { returnAccessToken } from '../../../Services/authService';


const baseURL = env?.microservice_assetsmgt;

const axiosInstance = axios.create({
  baseURL: baseURL,
});

// Add Authorization header
axiosInstance.interceptors.request.use(
    async (config) => {
    const token = await returnAccessToken("API");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },    
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance